// Phase 2 API helpers
import { api } from "./api";

export const tourApi = {
  list: (params = {}) => api.get("/tours", { params }).then((r) => r.data),
  get: (id) => api.get(`/tours/${id}`).then((r) => r.data),
  create: (body) => api.post("/tours", body).then((r) => r.data),
  patch: (id, body) => api.patch(`/tours/${id}`, body).then((r) => r.data),
  archive: (id) => api.post(`/tours/${id}/archive`).then((r) => r.data),
  deletePreflight: (id) =>
    api.post(`/tours/${id}/delete-preflight`).then((r) => r.data),
  hardDelete: (id, { confirm = "PERMANENTLY_DELETE", reason } = {}) =>
    api
      .delete(`/tours/${id}/permanent`, {
        data: reason ? { confirm, reason } : { confirm },
      })
      .then((r) => r.data),
  changeStatus: (id, to_status, reason) =>
    api.post(`/tours/${id}/status`, { to_status, reason }).then((r) => r.data),
  statusHistory: (id) => api.get(`/tours/${id}/status-history`).then((r) => r.data),
  listAssets: (id) => api.get(`/tours/${id}/assets`).then((r) => r.data),
  addAsset: (id, body) => api.post(`/tours/${id}/assets`, body).then((r) => r.data),
  removeAsset: (id, aid) => api.delete(`/tours/${id}/assets/${aid}`).then((r) => r.data),
  listDrivers: (id) => api.get(`/tours/${id}/drivers`).then((r) => r.data),
  addDriver: (id, body) => api.post(`/tours/${id}/drivers`, body).then((r) => r.data),
  removeDriver: (id, aid) => api.delete(`/tours/${id}/drivers/${aid}`).then((r) => r.data),
  // RC10l · Replacement swap on an existing driver assignment.
  // Preserves role, dates, asset link. Server validates eligibility.
  replaceDriver: (id, aid, body) => api.patch(`/tours/${id}/drivers/${aid}`, body).then((r) => r.data),
  listContacts: (id) => api.get(`/tours/${id}/contacts`).then((r) => r.data),
  addContact: (id, body) => api.post(`/tours/${id}/contacts`, body).then((r) => r.data),
  patchContact: (id, tcId, body) =>
    api.patch(`/tours/${id}/contacts/${tcId}`, body).then((r) => r.data),
  removeContact: (id, cid) => api.delete(`/tours/${id}/contacts/${cid}`).then((r) => r.data),
  listItinerary: (id) => api.get(`/tours/${id}/itinerary`).then((r) => r.data),
  addStop: (id, body) => api.post(`/tours/${id}/itinerary`, body).then((r) => r.data),
};

export const holdApi = {
  list: (params = {}) => api.get("/holds", { params }).then((r) => r.data),
  create: (body) => api.post("/holds", body).then((r) => r.data),
  release: (id, reason) => api.post(`/holds/${id}/release`, { reason }).then((r) => r.data),
  promote: (id) => api.post(`/holds/${id}/promote`).then((r) => r.data),
};

export const scheduleApi = {
  timeline: (start, end, resource = "both") =>
    api.get("/schedule", { params: { start, end, resource } }).then((r) => r.data),
  // RC10f · Super-Admin-only orphan assignment cleanup. Removes a
  // single assignment row whose parent tour no longer resolves.
  // Idempotent on repeat.
  removeOrphanDriverAssignment: (assn_id) =>
    api.delete(`/schedule/orphan-assignments/driver/${assn_id}`).then((r) => r.data),
  removeOrphanAssetAssignment: (assn_id) =>
    api.delete(`/schedule/orphan-assignments/asset/${assn_id}`).then((r) => r.data),
};

export const dispatchApi = {
  queue: () => api.get("/dispatch/queue").then((r) => r.data),
};
